"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=product-service.schemas.js.map